var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"50%","viewBox":"0 0 12 6","fill":"none"}},[_c('path',{attrs:{"d":"M10.9359 1L5.96795 4.97515L1 1.00308"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }